import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';

@Component({
  selector: 'app-input-radio-default',
  templateUrl: './input-radio-default.component.html',
  styleUrls: ['./input-radio-default.component.scss']
})
export class InputRadioDefaultComponent extends ComponentBase implements OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
  }

}
